module.exports = __webpack_public_path__ + "10a899f781f68a82369bff1c63b93222.jpg";